import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar, Stack } from 'mw-style-react';
import scss from './TextViewer.scss';

function TextViewer({ filePath }) {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTextContent = async () => {
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(
            `Failed to fetch: ${response.status} ${response.statusText}`
          );
        }
        const content = await response.text();
        setText(content);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchTextContent();
  }, [filePath]);

  if (loading) {
    return (
      <Stack fullWidth fullHeight alignItems="center" justifyContent="center">
        <ProgressBar type="circle" size="large" />
      </Stack>
    );
  }

  if (error) {
    return <div>Error loading file: {error}</div>;
  }

  return <div className={scss.textViewer}>{text}</div>;
}

TextViewer.propTypes = {
  filePath: PropTypes.string.isRequired,
};

export default TextViewer;
